import { Link } from "react-router-dom";
import { Sparkles, Github, Heart } from "lucide-react";
import { APP_CONFIG } from "@/lib/config";
import { SCENE_CATEGORIES } from "@/lib/constants";

export function Footer() {
  return (
    <footer className="relative z-10 border-t bg-muted/30">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="space-y-3">
            <div className="flex items-center gap-1.5 font-bold">
              <Sparkles className="h-5 w-5 text-brand" />
              <span>{APP_CONFIG.appName}</span>
            </div>
            <p className="text-sm text-muted-foreground">
              找到好用的 AI 提示词，让 AI 更好地为你工作。
            </p>
          </div>

          <div className="space-y-3">
            <h4 className="text-sm font-semibold">浏览</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/discover" className="hover:text-foreground">发现</Link></li>
              <li><Link to="/search" className="hover:text-foreground">搜索</Link></li>
              <li><Link to="/submit" className="hover:text-foreground">提交提示词</Link></li>
            </ul>
          </div>

          <div className="space-y-3">
            <h4 className="text-sm font-semibold">分类</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {SCENE_CATEGORIES.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                 <Link to={`/category/${cat.slug}`} className="hover:text-foreground">
                   {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-3">
            <h4 className="text-sm font-semibold">关于</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/my-submissions" className="hover:text-foreground">我的提交</Link></li>
              <li><Link to="/favorites" className="hover:text-foreground">我的收藏</Link></li>
              <li>
                <a href="#" className="inline-flex items-center gap-1 hover:text-foreground">
                  <Github className="h-3.5 w-3.5" /> GitHub
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 border-t pt-6 text-xs text-muted-foreground sm:flex-row">
          <p>© 2026 {APP_CONFIG.appName}. All rights reserved.</p>
          <p className="flex items-center gap-1">
            Made with <Heart className="h-3 w-3 fill-brand text-brand" /> for AI enthusiasts
          </p>
        </div>
      </div>
    </footer>
  );
}
